import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import GlobalStateProvider from './contexts/globalStateProvider';
// import * as Sentry from "@sentry/react"
import { datadogRum, } from '@datadog/browser-rum';
import { reactPlugin, ErrorBoundary } from '@datadog/browser-rum-react';
import ErrorBoundaryComponent from './components/Organisms/ErrorBoundary/ErrorBoundary.component';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// @ts-ignore
const buildDate = __APP_VERSION__?.buildDate || new Date().toISOString();

// const versionString = dayjs(buildDate).utc().format('MMMM D, YYYY') + ' at ' + dayjs(buildDate).utc().format('h:mm A [UTC]');
const versionString = dayjs(buildDate).utc().format('MMMM D, YYYY');

datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID!,
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
  site: 'us5.datadoghq.com',
  service: `WorkFlow15FE:${process.env.REACT_APP_DATADOG_NAME}`,
  env: process.env.REACT_APP_DATADOG_NAME,
  version: versionString,
  sessionSampleRate: 100, // 100% of sessions
  sessionReplaySampleRate: 100, // 100% of sessions
  trackResources: true, // Track resource loading
  trackUserInteractions: true,      // Captures clicks, scrolls, etc.
  defaultPrivacyLevel: 'allow', // Adjust for privacy needs
  plugins: [reactPlugin({ router: false })],
});

datadogRum.startSessionReplayRecording();

// Sentry.init({
//   dsn: "https://6eb050cd039974b68fa22a5af0631b36@o4509170244583424.ingest.us.sentry.io/4509171225133056",
//   environment: process.env.REACT_APP_SENTRY_NAME,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/workflow-uapi\.opsource\.cloud/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

function render() {

  console.warn(process.env.REACT_APP_DATADOG_NAME)

  const container = document.getElementById('root');
  const root = ReactDOM.createRoot(container!);

  const ErrorFallback = () => {
    return (
      <ErrorBoundaryComponent >
        <div>Error</div>
      </ErrorBoundaryComponent>
    )
  }

  return root.render(
    <StrictMode>
      <ErrorBoundary fallback={ErrorFallback}>
        <GlobalStateProvider>
          <App />
        </GlobalStateProvider>
      </ErrorBoundary>
    </StrictMode>,
  )
}
render();
